import React from 'react'

function ForgotPasswordPage() {
  return <div>Forget Password Page</div>
}

export default ForgotPasswordPage
